import { OrgHostingEpisode } from '@/modules/manager/components/org/hosting-episode';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(OrgHostingEpisode);

export const roles: string[] = [];
export const path = '/manager/:orgId/hosting-podcast/:podcastId/episode/:episodeId';
export const element = <AnimatedPage />